import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'messages',
    lazy: async () => ({ Component: (await import('./MessagesPage')).MessagesPage }),
  },
];
